// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header2 .block-limiter {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}

.header2 .brandhotelselector {
  margin-top: 5px;
}

.floatRight {
  float: right;
}

.marginBottom20 {
  margin-bottom: 20px;
}

h1 {
  text-align: left;
  color: #FFF;
}

.clearAll {
  clear: both;
}

.textRed {
  color: #EF374E !important;
}

.marginBottom20 {
  margin-bottom: 20px;
}

.textCenter {
  text-align: center !important;
}

.textRight {
  text-align: right !important;
}

.textLeft {
  text-align: left !important;
}

.assesementDate {
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  color: #071C3E;
  margin-top: 10px;
  margin-bottom: 20px;
}

.assessmtCat {
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  color: #071C3E;
}

.assessmtStatus {
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #919191;
}

.assessDtlContainer {
  margin-top: 20px;
}

.assessDtlChart {
  float: left;
  width: 33%;
}

.assessDtlAuth {
  float: left;
  width: 33%;
}

.assessDtlDate {
  float: left;
  width: 33%;
}

.assessDtlAuth .title {
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #1F1F1F;
}

.assessDtlDate .title {
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  display: block;
  text-align: right;
  color: #1F1F1F;
}

.assessDtlAuth .name {
  margin-bottom: 10px;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #919191;
}

.assessDtlDate .date {
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  display: block;
  align-items: center;
  text-align: right;
}

.assessDtlDate .statusCheck {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  display: block;
  text-align: right;
  color: #007AFF;
  margin-top: 20px;
}

.btnContainer {
  width: 100%;
}

.btnContainer button {
  width: 100%;
  height: 48px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AACA;EAAwB,iBAAA;EAAkB,kBAAA;EAAmB,mBAAA;AAG7D;;AAFA;EAA6B,eAAA;AAM7B;;AAJA;EAAY,YAAA;AAQZ;;AAPA;EAAgB,mBAAA;AAWhB;;AAVA;EAAG,gBAAA;EAAiB,WAAA;AAepB;;AAdA;EAAU,WAAA;AAkBV;;AAjBA;EAAS,yBAAA;AAqBT;;AApBA;EAAgB,mBAAA;AAwBhB;;AAvBA;EAAY,6BAAA;AA2BZ;;AA1BA;EAAW,4BAAA;AA8BX;;AA7BA;EAAU,2BAAA;AAiCV;;AAhCA;EAAgB,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,cAAA;EAAe,gBAAA;EAAiB,mBAAA;AAyCnG;;AAxCA;EAAa,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,cAAA;AA+ChE;;AA9CA;EAAgB,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,cAAA;AAqDnE;;AApDA;EAAoB,gBAAA;AAwDpB;;AAvDA;EAAgB,WAAA;EAAW,UAAA;AA4D3B;;AA3DA;EAAe,WAAA;EAAW,UAAA;AAgE1B;;AA/DA;EAAe,WAAA;EAAW,UAAA;AAoE1B;;AAnEA;EAAsB,mBAAA;EAAoB,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,aAAA;EAAc,mBAAA;EAAoB,kBAAA;EAAmB,cAAA;AA8ElJ;;AA7EA;EAAsB,mBAAA;EAAoB,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,cAAA;EAAe,iBAAA;EAAkB,cAAA;AAuF9H;;AAtFA;EAAqB,mBAAA;EAAoB,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,aAAA;EAAc,mBAAA;EAAoB,cAAA;AAgG9H;;AA/FA;EAAqB,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,cAAA;EAAe,mBAAA;EAAoB,iBAAA;AAwG3G;;AAvGA;EAA4B,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,cAAA;EAAe,iBAAA;EAAkB,cAAA;EAAgB,gBAAA;AAiHhI;;AAhHA;EAAc,WAAA;AAoHd;;AAnHA;EAAqB,WAAA;EAAa,YAAA;EAAa,gBAAA;EAAkB,mBAAA;EAAoB,kBAAA;EAAmB,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;AA8HzI","sourcesContent":[".header2 .block-limiter {\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.header2 .brandhotelselector {\n  margin-top: 5px;\n}\n\n.floatRight {\n  float: right;\n}\n\n.marginBottom20 {\n  margin-bottom: 20px;\n}\n\nh1 {\n  text-align: left;\n  color: #FFF;\n}\n\n.clearAll {\n  clear: both;\n}\n\n.textRed {\n  color: #EF374E !important;\n}\n\n.marginBottom20 {\n  margin-bottom: 20px;\n}\n\n.textCenter {\n  text-align: center !important;\n}\n\n.textRight {\n  text-align: right !important;\n}\n\n.textLeft {\n  text-align: left !important;\n}\n\n.assesementDate {\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 22px;\n  color: #071C3E;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.assessmtCat {\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 22px;\n  color: #071C3E;\n}\n\n.assessmtStatus {\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 20px;\n  color: #919191;\n}\n\n.assessDtlContainer {\n  margin-top: 20px;\n}\n\n.assessDtlChart {\n  float: left;\n  width: 33%;\n}\n\n.assessDtlAuth {\n  float: left;\n  width: 33%;\n}\n\n.assessDtlDate {\n  float: left;\n  width: 33%;\n}\n\n.assessDtlAuth .title {\n  margin-bottom: 10px;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #1F1F1F;\n}\n\n.assessDtlDate .title {\n  margin-bottom: 10px;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 20px;\n  display: block;\n  text-align: right;\n  color: #1F1F1F;\n}\n\n.assessDtlAuth .name {\n  margin-bottom: 10px;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  color: #919191;\n}\n\n.assessDtlDate .date {\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 20px;\n  display: block;\n  align-items: center;\n  text-align: right;\n}\n\n.assessDtlDate .statusCheck {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  display: block;\n  text-align: right;\n  color: #007AFF;\n  margin-top: 20px;\n}\n\n.btnContainer {\n  width: 100%;\n}\n\n.btnContainer button {\n  width: 100%;\n  height: 48px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 22px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
